import { IFilterDataPayload } from 'modules/admin-panel/pages/results/models';

export const prepareFilterPayload = (p: IFilterDataPayload) => ({
	...p,
	examples: p.examples?.map((ex: string) => {
		const newEx = ex.replace(/,/g, '|');
		return encodeURIComponent(newEx);
	}),
	city: encodeURIComponent(p.city || ''),
	office: encodeURIComponent(p.office || ''),
	businessUnit: encodeURIComponent(p.businessUnit || ''),
});
